var React = require('react');

function ArrowLineLeft (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M2.06 3.873h9.324c.173 0 .32.059.435.185.123.118.181.27.181.446a.592.592 0 0 1-.18.446.593.593 0 0 1-.436.186H2.06l2.7 2.77a.6.6 0 0 1 .181.437c0 .169-.065.32-.18.447a.567.567 0 0 1-.87.017L.213 5.034a.702.702 0 0 1-.164-.253.839.839 0 0 1 0-.573.737.737 0 0 1 .164-.252L3.891.185A.588.588 0 0 1 4.326 0c.164 0 .311.067.443.202.115.135.18.278.189.446a.608.608 0 0 1-.19.446l-2.7 2.77-.008.009z"}));
}

ArrowLineLeft.displayName = "ArrowLineLeft";

ArrowLineLeft.defaultProps = {"viewBox":"0 0 12 9"};

module.exports = ArrowLineLeft;

ArrowLineLeft.default = ArrowLineLeft;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-line-left.svg
// module id = 1252
// module chunks = 0